/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from 'formik';
import { Button, CircularProgress, Select, FormControl, FormControlLabel, Grid, InputLabel, Switch, FormHelperText, MenuItem } from '@mui/material';
import { useEffect } from 'react';
import { getAllApplication } from '../../../../../../../store/reducers/application/applicationAction';
import { getAllOrg } from '../../../../../../../store/reducers/organization/organizationAction';

const OrgAppForm = ({ errors, touched, values, handleBlur, handleChange,
    setFieldValue, handleClose, isSubmitting }) => {
    const dispatch = useDispatch();
    const applications = useSelector(state => state.application.applications);
    const organizations = useSelector(state => state.organization.organizations)

    useEffect(() => {
        dispatch(getAllApplication())
        dispatch(getAllOrg())
    }, [dispatch]);

    return (


        <Form>

            <Grid container spacing={4}>
                {values.hasOwnProperty("organizationID") && <Grid item xs={12} md={12} sm={12}>


                    <FormControl fullWidth error={Boolean(touched.organizationID && errors.organizationID)}>
                        <InputLabel htmlFor="outlined-status">Organization</InputLabel>
                        <Select
                            value={values.organizationID}
                            variant="outlined"
                            name="organizationID"
                            label="Owner"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            style={{ color: 'white' }}
                        >
                            {organizations?.Records?.length > 0 && organizations?.Records?.map((item) => (
                                <MenuItem value={item.organizationID}>
                                    {item.organizationName}
                                </MenuItem>
                            ))}


                        </Select>
                        <FormHelperText style={{ color: "red" }} >{errors.organizationID}</FormHelperText>

                    </FormControl>

                </Grid>}
                {values.hasOwnProperty("applicationID") && <Grid item xs={12} md={12} sm={12}>


                    <FormControl fullWidth error={Boolean(touched.applicationID && errors.applicationID)}>
                        <InputLabel htmlFor="outlined-status">Application</InputLabel>
                        <Select
                            value={values.applicationID}
                            variant="outlined"
                            name="applicationID"
                            label="Owner"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            style={{ color: 'white' }}
                        >
                            {applications?.Records?.length > 0 && applications?.Records?.map((item) => (
                                <MenuItem value={item.applicationID}>
                                    {item.applicationName}
                                </MenuItem>
                            ))}


                        </Select>
                        <FormHelperText style={{ color: "red" }} >{errors.applicationID}</FormHelperText>

                    </FormControl>

                </Grid>}
                {values.detailValue && <Grid item xs={12} md={6} sm={6}>
                    <FormControlLabel
                        control={<Switch />}
                        name="organizationApplicationDetails"
                        checked={values.detailValue === "true"}
                        onChange={(event, checked) => {
                            setFieldValue("detailValue", checked ? "true" : "false");
                        }}
                        label={values.detailValue === "true" ? 'Authorized' : 'Unauthorized'}
                    />
                </Grid>}
                <Grid item xs={12} md={12} sm={12}>
                    <Button
                        variant="contained"
                        color="primary"
                        type="submit" style={{ marginTop: '20px' }}
                        disabled={isSubmitting}>
                        {isSubmitting &&
                            <CircularProgress size={24} color='success' style={{ marginLeft: '10px' }} />} Save
                    </Button>
                    <Button variant="outlined" onClick={() => handleClose()} style={{ marginTop: '20px', marginLeft: '10px' }}>close</Button>

                </Grid>

            </Grid>
        </Form>

    )

}



export default OrgAppForm;